import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'
import { QuotationsListPage } from '../../../features/sales/quotations-list-page'
import { quotationSearchSchema } from '../../../features/sales/search'

export const Route = createFileRoute('/_app/quotations/')({
  validateSearch: quotationSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'sales.read'),
  component: QuotationsListPage,
})
